import { initials } from '../../lib/orbs'
import { cn } from '../../lib/utils'

// The one user avatar: a mist circle with ink initials (a company is an ink
// square, see OrgBadge), or an uploaded photo once ENG-131 lands.
const TEXT = { sm: 'text-label', md: 'text-caption', lg: 'text-body' } as const

export default function Avatar({
  name,
  size = 28,
  photoUrl,
  className,
}: {
  name?: string | null
  size?: number
  photoUrl?: string | null
  className?: string
}) {
  const scale = size >= 40 ? 'lg' : size >= 26 ? 'md' : 'sm'
  return (
    <span
      style={{ width: size, height: size }}
      className={cn('flex shrink-0 items-center justify-center overflow-hidden rounded-full', !photoUrl && 'bg-mist', className)}
    >
      {photoUrl ? (
        <img src={photoUrl} alt="" className="size-full object-cover" />
      ) : (
        <span className={cn('font-semibold text-foreground', TEXT[scale])}>{initials(name)}</span>
      )}
    </span>
  )
}
